interface IFilter {
  statusIds?: number[]
  areaIds?: number[]
  locationIds?: number[]
  supervisorIds?: number[]
  resourceIds?: number[]
  plantSectionIds?: number[]
  operationPostIds?: number[]
  assigneeIds?: number[]
  projectIds?: number[]
  abcIndicators?: number[]
  scheduleFeedbackTypes: number[]
  supervisorRole: 0 | 1
}

type TRole =
  | 'global-admin'
  | 'mechanical'
  | 'technician'
  | 'flsupervisor'
  | 'process'
  | 'scheduler'
  | 'admin'
  | 'read'

interface IPartialSite {
  id: number
  code: string
  name: string
  shiftEndTime: number
  shiftStartTime: number
  startOfWeek: number
  utcOffset: number
  dateFormat: number
  timeFormat: number
}

interface ISite extends IPartialSite {
  filters: IFilter
  roles: TRole[]
  customTileId: string
  timeZoneName: string
  country: string
  region: string
}

interface IMockedUser {
  email: string
  displayName: string
  isGlobalAdmin: boolean
  lanId: string
  domain: string
  selectedSite: ISite
  sites: IPartialSite[]
}

export const mockedMe: IMockedUser = {
  displayName: 'Doe, John',
  email: 'john.doe@tmocked.com',
  domain: 'sa',
  lanId: 'jd',
  isGlobalAdmin: true,
  sites: [
    {
      id: 1,
      code: 'BRC',
      name: 'Baton Rouge Complex',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 2,
      code: 'BMT',
      name: 'Beaumont Refinery',
      shiftEndTime: 17,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 3,
      code: 'BTW',
      name: 'Baytown Complex',
      shiftEndTime: 20,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 4,
      code: 'BIR',
      name: 'Billings Refinery',
      shiftEndTime: 17,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -6,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 5,
      code: 'JOL',
      name: 'Joliet Refinery',
      shiftEndTime: 17,
      shiftStartTime: 8,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 6,
      code: 'BMP',
      name: 'Beaumont Polyethylene',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 7,
      code: 'ALT',
      name: 'Altona Refinery',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 10,
      dateFormat: 3,
      timeFormat: 2,
    },
    {
      id: 8,
      code: 'BRO',
      name: 'Baton Rouge Polyolefins',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 9,
      code: 'SNC',
      name: 'Singapore Chemicals',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 8,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 10,
      code: 'FAC',
      name: 'Fawley Complex',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 1,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 11,
      code: 'FIF',
      name: 'Fife Ethylene',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 1,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 12,
      code: 'BMC',
      name: 'Beaumont Chemicals',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 0,
      timeFormat: 0,
    },
    {
      id: 13,
      code: 'BRP',
      name: 'Baton Rouge Plastics',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 14,
      code: 'SAR',
      name: 'Sarnia Complex',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -4,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 15,
      code: 'STR',
      name: 'Strathcona Complex',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -6,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 16,
      code: 'SRI',
      name: 'Sriracha Refinery',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 7,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 17,
      code: 'BTM',
      name: 'Mont Belvieu Plastics',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 18,
      code: 'BTT',
      name: 'Baytown Technology',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 19,
      code: 'NAN',
      name: 'Nanticoke Refinery',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -4,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 20,
      code: 'RPI',
      name: 'Rotterdam Plasticisers',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 21,
      code: 'BTO',
      name: 'Baytown Olefins',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 22,
      code: 'NDC',
      name: 'NDG Chemicals',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 1,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 26,
      code: 'SLA',
      name: 'Slagen R&S',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 27,
      code: 'DWSD',
      name: 'Demo Site',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 28,
      code: 'AMP',
      name: 'Antwerp/Meerhout Polymers',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 101,
      code: 'SNJ',
      name: 'Singapore Jurong Ref',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 8,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 102,
      code: 'SNP',
      name: 'Singapore PAC Ref',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 8,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 103,
      code: 'ANR',
      name: 'Antwerp Refinery',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 1,
      utcOffset: 2,
      dateFormat: 1,
      timeFormat: 1,
    },
    {
      id: 104,
      code: 'PEN',
      name: 'Pensacola',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 105,
      code: 'DWST',
      name: 'Demo Site - Testing',
      shiftEndTime: 17,
      shiftStartTime: 8,
      startOfWeek: 5,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 107,
      code: 'GCG',
      name: 'Gulf Coast Growth Venture',
      shiftEndTime: 17,
      shiftStartTime: 7,
      startOfWeek: 1,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 108,
      code: 'RTC',
      name: 'Rotterdam Refinery',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 5,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 109,
      code: 'MUS',
      name: 'US Midstream EMPCo',
      shiftEndTime: 17,
      shiftStartTime: 7,
      startOfWeek: 1,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 2,
    },
    {
      id: 110,
      code: 'MCA',
      name: 'Canada Midstream CFO',
      shiftEndTime: 17,
      shiftStartTime: 7,
      startOfWeek: 1,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 111,
      code: 'CHN',
      name: 'China 1',
      shiftEndTime: 17,
      shiftStartTime: 8,
      startOfWeek: 5,
      utcOffset: 8,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 112,
      code: 'FOS',
      name: 'Fos-sur-Mer',
      shiftEndTime: 16,
      shiftStartTime: 7,
      startOfWeek: 1,
      utcOffset: 2,
      dateFormat: 3,
      timeFormat: 1,
    },
    {
      id: 113,
      code: 'ASH',
      name: 'Asher Lubes Plant',
      shiftEndTime: 19,
      shiftStartTime: 7,
      startOfWeek: 0,
      utcOffset: -5,
      dateFormat: 3,
      timeFormat: 1,
    },
  ],
  selectedSite: {
    filters: {
      projectIds: [],
      statusIds: [],
      supervisorRole: 0,
      plantSectionIds: [],
      locationIds: [],
      areaIds: [],
      resourceIds: [],
      operationPostIds: [],
      assigneeIds: [],
      supervisorIds: [],
      abcIndicators: [],
      scheduleFeedbackTypes: [],
    },
    roles: [
      'global-admin',
      'mechanical',
      'process',
      'scheduler',
      'admin',
      'read',
    ],
    customTileId: 'default',
    name: 'Billings Refinery',
    code: 'BIR',
    timeZoneName: 'Mountain Standard Time',
    country: 'United States',
    region: 'NA',
    shiftStartTime: 7,
    shiftEndTime: 17,
    startOfWeek: 5,
    utcOffset: -6,
    dateFormat: 3,
    timeFormat: 1,
    id: 4,
  },
}
